// Native (Capacitor) uygulamaya özgü başlatma. Web'de sessizce hiçbir şey yapmaz.
import { Capacitor } from "@capacitor/core";
import { toast } from "sonner";

export async function initNative() {
  if (!Capacitor.isNativePlatform()) return;

  // CSS'in native'e özel kuralları (seçim/callout/overscroll kapatma) devreye girsin.
  document.documentElement.classList.add("is-native");

  // Uygulamalarda pinch-zoom olmaz; viewport'u sabitle.
  // iOS: viewport-fit=cover GEREKLİ — yoksa env(safe-area-inset-*) hep 0 döner
  // ve çentik (notch) boşlukları hesaplanamaz.
  // Android: viewport-fit=cover KULLANMA — içerik durum çubuğunun altına taşıyor.
  const vp = document.querySelector('meta[name="viewport"]');
  if (vp) {
    const base = "width=device-width, initial-scale=1, maximum-scale=1, user-scalable=no";
    vp.setAttribute(
      "content",
      Capacitor.getPlatform() === "ios" ? `${base}, viewport-fit=cover` : base
    );
  }

  // Durum çubuğu: beyaz zemin + koyu ikonlar (uygulama header'ıyla uyumlu).
  try {
    const { StatusBar, Style } = await import("@capacitor/status-bar");
    await StatusBar.setStyle({ style: Style.Light });
    if (Capacitor.getPlatform() === "android") {
      await StatusBar.setBackgroundColor({ color: "#ffffff" });
    }
  } catch {
    /* eklenti yoksa sorun değil */
  }

  // Android donanım geri tuşu: tarayıcı geçmişinde geri git; kökteyse
  // "çıkmak için tekrar bas" kalıbı (yanlışlıkla çıkışı önler).
  try {
    const { App: CapApp } = await import("@capacitor/app");
    let lastBackPress = 0;
    CapApp.addListener("backButton", ({ canGoBack }) => {
      if (canGoBack) {
        window.history.back();
        return;
      }
      const now = Date.now();
      if (now - lastBackPress < 2000) {
        CapApp.exitApp();
      } else {
        lastBackPress = now;
        toast("Çıkmak için tekrar geri tuşuna basın.");
      }
    });
  } catch {
    /* eklenti yoksa sorun değil */
  }

  // Klavye açıkken <html>'e sınıf ekle — CSS gereksiz alt boşlukları kaldırır
  // (ör. sohbet yazma çubuğu ile klavye arasındaki safe-area boşluğu).
  try {
    const { Keyboard } = await import("@capacitor/keyboard");
    Keyboard.addListener("keyboardWillShow", () =>
      document.documentElement.classList.add("kb-open")
    );
    Keyboard.addListener("keyboardWillHide", () =>
      document.documentElement.classList.remove("kb-open")
    );
  } catch {
    /* eklenti yoksa sorun değil */
  }

  // Açılış (splash) ekranını uygulama hazır olunca gizle.
  try {
    const { SplashScreen } = await import("@capacitor/splash-screen");
    await SplashScreen.hide();
  } catch {
    /* eklenti yoksa sorun değil */
  }
}
